<div fxLayout="row grid" class="card">
    <div fxFlex="25" *ngFor="let product of productList" fxFlex.lt-md="50" class="product-img pointer" [ngStyle]="{'background-image': 'url(' + storageUrl + product.thumbCurta + ')',
                    'background-position': 'center center',
                    'background-color': '#039AE899',
                    'background-repeat': 'no-repeat',
                    'background-blend-mode': 'multiply',
                    'background-size': 'cover'}"
        routerLink="/products/{{productType(product.tipo)}}/details/{{product.id}}">
        <div class="card-content">
            <div class="card-margin">
                <div fxLayout="column" fxLayoutGap="20px" fxLayoutGap.lt-xl="10px" fxLayoutAlign="space-between center"
                    fxFlexFill>
                    <span
                        class="card-title">{{product.tituloAlternativo ? product.tituloAlternativo : product.titulo }}</span>
                    <span class="card-subtitle">{{product.formato}}</span>
                    <app-button [fontFamily]="'Oswald'" [txt]="'SAIBA MAIS'" [btnClass]="'btn-white product-card'">
                    </app-button>
                </div>
            </div>
        </div>
    </div>
    <div fxFlex>
        <app-cadastre-se-stripe [isDynamic]="true" [title]="blueStripeTitle">
        </app-cadastre-se-stripe>
    </div>
</div>